import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";

const LazyOnView = ({ children, placeholderHeight = 300, fallback = null, animation = true }) => {
  const ref = useRef(null);
  const [hasBeenVisible, setHasBeenVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasBeenVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: "0px" }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const animationVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  return (
    <div ref={ref} style={{ minHeight: !hasBeenVisible ? placeholderHeight : undefined }}>
      {hasBeenVisible ? (
        animation ? (
          <motion.div
            initial="hidden"
            animate="visible"
            variants={animationVariants}
          >
            {children}
          </motion.div>
        ) : (
          children
        )
      ) : (
        fallback
      )}
    </div>
  );
};

export default LazyOnView;
